import { I18n } from '@aws-amplify/core';
import { FeatureStateTag } from '@/components/ui/FeatureStateTag';
import * as S from './styles';

interface MenuLabelProps {
	label: string;
}

type FeatureState = 'BETA' | 'Early Access';

const FEATURE_STATES: Record<string, FeatureState> = {
	EWA: 'BETA',
	Psychosocial: 'Early Access'
} as const;

export function MenuLabel({ label }: Readonly<MenuLabelProps>) {
	const featureState = FEATURE_STATES[label] as FeatureState | undefined;

	if (featureState) {
		return (
			<S.NewMenuContainer>
				{I18n.get(label)} <FeatureStateTag feat_state={featureState} />
			</S.NewMenuContainer>
		);
	}

	return <>{I18n.get(label)}</>;
}
